package org.matthewo.datasource

import org.matthewo.api.Schedule
import org.matthewo.schema.CRI_YEAR_MAP

object CRI {

    const val BASE_ROUTE = "https://results.chicagoroboticsinvitational.com"

    fun eventURL(year: Any?, code: String) =
        "$BASE_ROUTE/${CRI_YEAR_MAP[year.toString().toIntOrNull()]}/events/$code"

    fun matchesURL(year: Any?, code: String) =
        "${eventURL(year, code)}/matches"

    private fun resultsURL(year: Int, code: String, level: Schedule.Match.Level, number: Int): String {
        val matchPrefix = when (level) {
            Schedule.Match.Level.QUAL -> "Q"
            Schedule.Match.Level.SEMIFINAL -> "SF"
            Schedule.Match.Level.FINAL -> "F"
            Schedule.Match.Level.PLAYOFF -> "P"
        }
        return "${matchesURL(year, code)}?match=$matchPrefix-$number"
    }

    fun resultsURL(year: Int, code: String, level: Schedule.Match.Level, number: Int, series: Int) = resultsURL(
        year,
        code,
        level,
        if (Schedule.Match.Level.PLAYOFF != level) number else series,
    )
}
